import reducer from './reducer';
import actions from './actions';
import resolvers from './resolvers';
import selectors from './selectors';
import { createReduxStore } from '@wordpress/data';
import { VENDOR_QUOTES_STORE } from '../../vendor-dashboard/constants';

const quotesStore = createReduxStore( VENDOR_QUOTES_STORE, {
    reducer,
    actions,
    selectors,
    resolvers,
} );

export default quotesStore;
